module.exports = __webpack_public_path__ + "img/045C5C_0DBDBD_049393_04A4A4-256px.884308dd.png";